(function (angular) {
    'use strict';

    angular
        .module('app.grievance')
        .controller('app.grievance.grievanceController', [
            '$scope',
            '$location',
            'states', 
            'ui',
            '$state',
            '$window',
            'app.grievance.grievanceService',
            grievanceController
        ]);

    function grievanceController($scope, $location, states, ui, $state, $window, service) {
        $scope.$on('$locationChangeStart', function(event, newUrl, oldUrl) {
            if(newUrl.split('/#/').length > 1 && newUrl.split('/#/')[1].indexOf('grievance') == 0) {
                initializeCurrentSection();
            }
        });

        var vm = this;
        vm.state = '';
        vm.stateFolder = 'assets/grievances';
        vm.states = states;
        vm.section = 0;
        vm.grievanceInfo = {
            memberInfo: {
                firstName: '',
                lastName: '',
                mainSubscriber: '',
                phone: '',
                email: '',
                address: {
                    streetAddress: '',
                    city: '',
                    state: '',
                    zip: ''
                }
            },
            dentistInfo: {
                name: '',
                phone: '',
                address: {
                    streetAddress: '',
                    city: '',
                    state: '',
                    zip: ''
                }
            },
            grievanceDescription: '',
            brand: siteContent.theme
        };

        vm.isLoadingGrievanceText = false;
        vm.hasGrievanceText = false;
        vm.onGrievanceTextLoading = onGrievanceTextLoading;
        vm.onGrievanceTextMissing = onGrievanceTextMissing;
        vm.onGrievanceTextExists = onGrievanceTextExists;
        vm.submitForm = submitForm;
        vm.continue = showNextSection;
        vm.showSection = showSection;

        initialize();

        function onGrievanceTextLoading() {
            vm.isLoadingGrievanceText = true;
            vm.hasGrievanceText = false;
        }

        function onGrievanceTextMissing() {
            vm.isLoadingGrievanceText = false;
            vm.hasGrievanceText = false;
            initializeCurrentSection()
        }

        function onGrievanceTextExists() {
            vm.isLoadingGrievanceText = false;
            vm.hasGrievanceText = true;
            initializeCurrentSection();
        }

        function initializeCurrentSection() {
            var section = $location.search().section;
            if(section && section !== null) {
                section -= (vm.state != '' && vm.hasGrievanceText ? 1 : 0);
            } else {
                section = (vm.state != '' && vm.hasGrievanceText ? 0 : 1);
            }

            vm.section = section;
        }

        function initialize() {
            vm.state = $location.search().state;
            if(vm.state === null || typeof vm.state === 'undefined') {
                vm.state = '';
            } else {
                vm.state = vm.state.toUpperCase();
            }

            initializeCurrentSection();
        }

        function submitForm() {
            ui.block();
            service.submitGrievanceForm(vm.grievanceInfo).then(function() {
                $state.go('app.grievancesuccess');
            }).catch(function rejected(response) {
                ui.handleError(response);
            }).finally(function () {
                ui.unblock();
            });
        }

        function showNextSection() {
            showSection(vm.section +1);
        }

        function showSection(sectionNum) {
            var urlSection = sectionNum;
            if(vm.state !== '' && vm.hasGrievanceText) {
                urlSection += 1;
            }

            var currentSearch = $location.search();

            $window.history.pushState($window.location.href, 'Grievance Form');

            $location.search(angular.merge(currentSearch, {section: urlSection }));
            $location.replace();
            
            vm.section = sectionNum;
            $window.scrollTo(0,0);
        }
    }
})(angular);
